import { useCallback, useEffect, useState } from "react";
import "./styles.scss";
import logo from "../../config/logo-color.svg";
import getTicket from "../../assets/images/ticketbtn.svg";
import Menu from "./menu.json";
import { Container } from "react-bootstrap";
import { CgMenuRound } from "react-icons/cg";
import CustomDrawer from "./drawer";
import { useNavigate } from "react-router-dom";
const Fade = require("react-reveal/Fade");

const Header = (props: any) => {
  const navigation = useNavigate();
  const [showTicket, setShowTicket] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = useCallback(() => {
    if (window.scrollY > 100) {
      setShowTicket(true);
    } else {
      setShowTicket(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <nav className="Header">
      <Container className="Header-Container">
        <div className="Header-Box">
          <Fade top>
            <img
              src={logo}
              onClick={() => navigation("/")}
              alt="teenzania"
              className="Header-logo"
            />
          </Fade>

          <div className="Header-Box2">
            {Menu?.map((item: any, index: number) => (
              <Fade top key={index} delay={index * 30}>
                <div
                  className="Header-items"
                  onClick={() => navigation(item?.path)}
                >
                  {item?.name}
                </div>
              </Fade>
            ))}
          </div>

          {/* Fixed-width container for ticket + menu */}
          <div className="Header-ticketWrapper">
            {showTicket && (
              <Fade top delay={300}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={getTicket}
                    alt="ticket"
                    className="Header-ticket"
                    onClick={() => navigation("/booking")}
                  />
                  <div className="Header-mobileMenu">
                    <CgMenuRound size={40} onClick={() => setIsOpen(true)} />
                  </div>
                </div>
              </Fade>
            )}
          </div>
        </div>
      </Container>

      {isOpen && (
        <CustomDrawer
          onClose={() => setIsOpen(false)}
          open={isOpen}
          options={Menu}
        />
      )}
    </nav>
  );
};

export default Header;
